import { BsPerson } from "react-icons/bs";
import Input from "@/components/input/Input";

function PersonalInputs({ register, updating, isPending, errors, ApiError }) {
    return (
        <>
            <div className="flex flex-col items-center justify-center gap-4 lg:flex-row lg:flex lg:justify-center lg:items-center">
                {/* FirstName */}
                <Input
                    type="text"
                    id="firstName"
                    name="firstName"
                    disabled={isPending || updating}
                    label="الإسم الأول*"
                    size="halfWidth"
                    icon={BsPerson}
                    register={register("firstName", {
                        required: "برجاء إدخال الأسم الأول ",
                    })}
                    error={errors?.firstName?.message}
                />

                {/* SecondName */}
                <Input
                    type="text"
                    name="secondName"
                    id="secondName"
                    disabled={isPending || updating}
                    label="الإسم الثاني*"
                    icon={BsPerson}
                    register={register("secondName", {
                        required: "برجاء إدخال الأسم الثاني ",
                    })}
                    error={errors?.secondName?.message}
                />
            </div>

            {/* LastName */}
            <div className="flex flex-col items-center justify-center gap-4 lg:flex-row lg:flex lg:justify-center lg:items-center">
                <Input
                    type="text"
                    name="email"
                    id="email"
                    // disabled={isPending || updating}
                    disabled={true}
                    label="الأيميل*"
                    icon={BsPerson}
                    register={register("email", {
                        required: "برجاء إدخال الإيميل ",
                    })}
                    error={
                        errors?.email?.message ||
                        ApiError?.response?.data?.errors?.email?.[0]
                    }
                />
            </div>
        </>
    );
}

export default PersonalInputs;
